import { memo } from "react";
import Page from "components/page/Page";
import { Helmet } from "react-helmet";
import Card from "components/card/Card";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { PageCollapseWidth } from "../../constants";

const ToolSection = styled.div`
  margin-bottom: 2rem;
`;

const ToolTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 700;
  margin-bottom: 0.5rem;

  a {
    color: var(--primary-color);
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ToolDescription = styled.p`
  margin-bottom: 0.5rem;
  color: var(--bs-body-color);
`;

const Base64Page = () => {
  return (
    <>
      <Helmet>
        <title>Base64 Tools – Encode and Decode Base64 | ToolWeaver</title>
        <meta
          name="description"
          content="Free online Base64 tools. Encode text to Base64 or decode Base64 to readable text instantly. Your input is processed to produce the result and is not stored."
        />
        <link rel="canonical" href="https://toolweaver.com/base64" />
      </Helmet>
      <Page>
        <Card collapseOnWidth={PageCollapseWidth} title="Base64 Tools">
          <span className="d-block mb-4">
            Base64 is a binary-to-text encoding scheme that represents binary
            data in an ASCII string format. Use our free tools to encode or
            decode Base64 data instantly.
          </span>

          <ToolSection>
            <ToolTitle>
              <Link to="/base64encode">Base64 Encoder</Link>
            </ToolTitle>
            <ToolDescription>
              Convert plain text to Base64 encoding. Perfect for encoding data
              for safe transmission over text-based protocols.
            </ToolDescription>
          </ToolSection>

          <ToolSection>
            <ToolTitle>
              <Link to="/base64decode">Base64 Decoder</Link>
            </ToolTitle>
            <ToolDescription>
              Decode Base64-encoded strings back to readable text. Instantly
              convert Base64 data to its original format.
            </ToolDescription>
          </ToolSection>
        </Card>
      </Page>
    </>
  );
};

export default memo(Base64Page);
